import axios from 'axios';
const api = axios.create({baseURL: "https://cfapi.farmaciaevidence.com.br/api/"})
export default api;